import { useCallback, useEffect, useState } from 'react';
import { useLocale } from '../context/LocaleContext';
import { localizeStoredServiceType } from '../lib/serviceI18n';
import { supabase } from '../lib/supabase';

export function useServiceCatalog() {
  const { locale, t } = useLocale();
  const [catalog, setCatalog] = useState([]);

  useEffect(() => {
    let alive = true;
    supabase
      .from('services')
      .select('id, name, name_ar')
      .then(({ data }) => {
        if (alive) setCatalog(data || []);
      });
    return () => {
      alive = false;
    };
  }, []);

  const serviceLabel = useCallback(
    (type, fallbackKey = 'common.service') => {
      const label = localizeStoredServiceType(type, catalog, locale);
      return label || t(fallbackKey);
    },
    [catalog, locale, t],
  );

  const serviceSearchHay = useCallback(
    (type) =>
      [
        type,
        localizeStoredServiceType(type, catalog, 'en'),
        localizeStoredServiceType(type, catalog, 'ar'),
      ]
        .filter(Boolean)
        .join(' '),
    [catalog],
  );

  return { catalog, serviceLabel, serviceSearchHay };
}
